import { render, staticRenderFns } from "./Employees.html?vue&type=template&id=63dace4e&external"
import script from "./Employees.js?vue&type=script&lang=js&external"
export * from "./Employees.js?vue&type=script&lang=js&external"
import style0 from "./Employees.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports